import * as SentryBrowser from "@sentry/browser";
import * as Sentry from "@sentry/react";

import { getAppConfig, getRuntimeEnvironment } from "../config";
import { startLongTaskReporter } from "./longTaskReporter";
import { applyRouteToEvent } from "./sentry-route";
// Configuration docs: https://docs.sentry.io/platforms/javascript/guides/react/#configure

if (getAppConfig().sentryConfig) {
    Sentry.init({
        dsn: getAppConfig().sentryConfig.dsn, // Replace with your actual DSN
        integrations: [SentryBrowser.browserTracingIntegration()],
        tracesSampleRate: getAppConfig().sentryConfig.tracesSampleRate,
        environment: getRuntimeEnvironment(),
        // This app routes with HashRouter, so `browserTracingIntegration()` names
        // every transaction after `location.pathname` — which is `/` on every
        // page, on every issue. See `sentry-route.ts`: this names the ERROR with
        // the route from the fragment. Transactions are deliberately untouched.
        beforeSend: (event) =>
            applyRouteToEvent(
                event,
                typeof window === "undefined" ? undefined : window.location
            )
    });
    // A freeze never throws — see longTaskReporter.ts. Started only where Sentry is.
    startLongTaskReporter();
}
